module.exports = __webpack_public_path__ + "static/orc_tattoo_elf-354867bff82e1b32502dffe738fb7689.png";